import { LandingLayoutWithoutSidebar } from "PFApp/components/landing_layout";
import { useOnboarding } from "PFApp/onboarding/use_onboarding";
import CVUpload from "PFApp/profiles/common/cv_upload";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import css from "../../profiles/common/cv_upload.less";
import OnboardingBox from "../parts/onboarding_box";

const CVUploadStep = () => {
  const { currentAccount, navigateNext } = useOnboarding("cv");

  // this step doesn't need any save to the profile
  // CVUpload MIGHT communicate with api by sending file / waiting for the pusher message
  useEffect(() => {
    const conf = currentAccount.cv_parser_config;
    if (conf && !conf.enabled) {
      navigateNext();
    }
  }, [currentAccount]);

  const { t } = useTranslation("onboarding", { keyPrefix: "common.cvUpload" });

  const processingMessage = <div className={css.information}>{t("processingCV")}</div>;

  return (
    <LandingLayoutWithoutSidebar>
      <OnboardingBox qaId="OnboardingBox.CVUploadStep">
        <CVUpload
          processingMessage={processingMessage}
          handleCancel={navigateNext}
          handleSuccess={navigateNext}
          handleTimeout={navigateNext}
        />
      </OnboardingBox>
    </LandingLayoutWithoutSidebar>
  );
};

export default CVUploadStep;
